/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';
import type { InternalApiPeriodicScenarioAttributes } from './InternalApiPeriodicScenarioAttributes';
import {
    InternalApiPeriodicScenarioAttributesFromJSON,
    InternalApiPeriodicScenarioAttributesFromJSONTyped,
    InternalApiPeriodicScenarioAttributesToJSON,
    InternalApiPeriodicScenarioAttributesToJSONTyped,
} from './InternalApiPeriodicScenarioAttributes';
import type { InternalApiScenarioVersionStatus } from './InternalApiScenarioVersionStatus';
import {
    InternalApiScenarioVersionStatusFromJSON,
    InternalApiScenarioVersionStatusFromJSONTyped,
    InternalApiScenarioVersionStatusToJSON,
    InternalApiScenarioVersionStatusToJSONTyped,
} from './InternalApiScenarioVersionStatus';
import type { InternalApiScenarioLanguage } from './InternalApiScenarioLanguage';
import {
    InternalApiScenarioLanguageFromJSON,
    InternalApiScenarioLanguageFromJSONTyped,
    InternalApiScenarioLanguageToJSON,
    InternalApiScenarioLanguageToJSONTyped,
} from './InternalApiScenarioLanguage';

/**
 * 
 * @export
 * @interface InternalApiScenarioVersion
 */
export interface InternalApiScenarioVersion {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersion
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioVersion
     */
    versionId: number;
    /**
     * 
     * @type {InternalApiScenarioVersionStatus}
     * @memberof InternalApiScenarioVersion
     */
    status: InternalApiScenarioVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersion
     */
    details: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersion
     */
    query: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersion
     */
    note?: string;
    /**
     * 
     * @type {InternalApiScenarioLanguage}
     * @memberof InternalApiScenarioVersion
     */
    language: InternalApiScenarioLanguage;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioVersion
     */
    suppressionInterval?: number;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiScenarioVersion
     */
    updatedBy: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioVersion
     */
    updatedTime: Date;
    /**
     * 
     * @type {InternalApiPeriodicScenarioAttributes}
     * @memberof InternalApiScenarioVersion
     */
    periodicScenarioAttributes?: InternalApiPeriodicScenarioAttributes;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiScenarioVersion
     */
    parameters: Array<InternalApiScenarioVersionParameter>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersion
     */
    logic?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScenarioVersion
     */
    segments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScenarioVersion
     */
    excludedSegments?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScenarioVersion
     */
    includeRelatedTransactions?: boolean;
}



/**
 * Check if a given object implements the InternalApiScenarioVersion interface.
 */
export function instanceOfInternalApiScenarioVersion(value: object): value is InternalApiScenarioVersion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('versionId' in value) || value['versionId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('query' in value) || value['query'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('updatedTime' in value) || value['updatedTime'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    return true;
}

export function InternalApiScenarioVersionFromJSON(json: any): InternalApiScenarioVersion {
    return InternalApiScenarioVersionFromJSONTyped(json, false);
}

export function InternalApiScenarioVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioVersion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'versionId': json['versionId'],
        'status': InternalApiScenarioVersionStatusFromJSON(json['status']),
        'details': json['details'],
        'query': json['query'],
        'note': json['note'] == null ? undefined : json['note'],
        'language': InternalApiScenarioLanguageFromJSON(json['language']),
        'suppressionInterval': json['suppressionInterval'] == null ? undefined : json['suppressionInterval'],
        'updatedBy': InternalApiUserBasicDetailsFromJSON(json['updatedBy']),
        'updatedTime': (new Date(json['updatedTime'])),
        'periodicScenarioAttributes': json['periodicScenarioAttributes'] == null ? undefined : InternalApiPeriodicScenarioAttributesFromJSON(json['periodicScenarioAttributes']),
        'parameters': ((json['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
        'logic': json['logic'] == null ? undefined : json['logic'],
        'segments': json['segments'] == null ? undefined : json['segments'],
        'excludedSegments': json['excludedSegments'] == null ? undefined : json['excludedSegments'],
        'includeRelatedTransactions': json['includeRelatedTransactions'] == null ? undefined : json['includeRelatedTransactions'],
    };
}

export function InternalApiScenarioVersionToJSON(json: any): InternalApiScenarioVersion {
    return InternalApiScenarioVersionToJSONTyped(json, false);
}

export function InternalApiScenarioVersionToJSONTyped(value?: InternalApiScenarioVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'versionId': value['versionId'],
        'status': InternalApiScenarioVersionStatusToJSON(value['status']),
        'details': value['details'],
        'query': value['query'],
        'note': value['note'],
        'language': InternalApiScenarioLanguageToJSON(value['language']),
        'suppressionInterval': value['suppressionInterval'],
        'updatedBy': InternalApiUserBasicDetailsToJSON(value['updatedBy']),
        'updatedTime': value['updatedTime'].toISOString(),
        'periodicScenarioAttributes': InternalApiPeriodicScenarioAttributesToJSON(value['periodicScenarioAttributes']),
        'parameters': ((value['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
        'logic': value['logic'],
        'segments': value['segments'],
        'excludedSegments': value['excludedSegments'],
        'includeRelatedTransactions': value['includeRelatedTransactions'],
    };
}

